import { Request } from '@/services/api';

export class EventsManagementService {
  static list(query: string) {
    return Request().get(`/admin/events-management/events${query || ''}`);
  }

  static recipients(eventId: number, query: string) {
    return Request().get(`/admin/events-management/events/${eventId}/recipients${query || ''}`);
  }

  static requeue(eventId: number, resetSentRecipients: boolean) {
    return Request().post(`/admin/events-management/events/${eventId}/requeue`, {
      resetSentRecipients,
    });
  }
}
